module.exports = __webpack_public_path__ + "img/ht.34eb5f59.svg";